<form [formGroup]="iackKorting">
    <div class="row">
        <div>
            <snelstart-ui-number-form-control
                    formControlName="arbeidsInkomenPartner"
                    id="arbeidsInkomenPartner"
                    class="custom-input-250"
                    [decimals]="0"
                    align="right"
                    prefix="€"
                    label="Arbeidsinkomen partner"
                    (change)="saveForm()"

            >
            </snelstart-ui-number-form-control>
            <span class="pt-4"
                  snelstartUiTooltip="Het arbeidsinkomen en verzamelinkomen van de partner zijn van belang voor het bepalen van de heffingskortingen. Neem deze gegevens over uit de aangifte van de partner."> &#x24D8;</span>
        </div>
        <div>
            <snelstart-ui-number-form-control
                    formControlName="verzamelInkomenPartner"
                    id="verzamelInkomenPartner"
                    class="custom-input-250"
                    [decimals]="0"
                    align="right"
                    prefix="€"
                    label="Verzamelinkomen partner"
                    (change)="saveForm()"

            >
            </snelstart-ui-number-form-control>
        </div>
    </div>
</form>

